/**
 * AURA Master Library Page
 * Wrapper that uses the unified library component in master mode.
 */
import React from 'react';
import RegulatoryLibraryUnified from './RegulatoryLibraryUnified';

const MasterLibraryPage = () => {
  return <RegulatoryLibraryUnified mode="master" />;
};

export default MasterLibraryPage;
